module.exports = __webpack_public_path__ + "static/media/jessy_chen.b8ed7cc2.jpg";